import { Box, ButtonProps, chakra, Text, Image } from "@chakra-ui/react";
import React from "react";
import styled from "styled-components";
import { CloseIcon } from "../icons";
import WarnIcon from "./assets/warn.png";

interface BottomButtonProps {
  variant?: "primary" | "secondary";
  onClick?: () => void;
  children?: React.ReactNode;
  onCloseError?: () => void;
  errorMessage?: string;
}

const StyledButton = chakra(styled.button<ButtonProps>`
  width: 100%;
  height: 100px;
  font-size: 32px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ variant }) =>
    variant === "secondary"
      ? `
      background-color: #fff;
      color: #333;
    `
      : `
      background-color: #d87628;
      color: #fff;
    `}
`);

const BottomButton: React.FC<BottomButtonProps> = ({
  variant = "primary",
  onClick,
  children,
  onCloseError,
  errorMessage,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
      }}
    >
      {errorMessage && (
        <Box
          sx={{
            width: "375px",
            backgroundColor: "#F13434",
            position: "relative",
            padding: "12px 30px",
          }}
        >
          <Text
            sx={{
              fontSize: "12px",
              color: "#fff",
              textAlign: "center",
            }}
          >
            <Image
              src={WarnIcon}
              alt="warn"
              sx={{
                width: "12px",
                display: "inline-block",
                marginRight: "4px",
              }}
            />
            {errorMessage}
          </Text>
          <CloseIcon
            style={{
              width: "16px",
              height: "16px",
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={onCloseError}
          />
        </Box>
      )}
      <StyledButton variant={variant} onClick={onClick}>
        {children}
      </StyledButton>
    </Box>
  );
};

export default BottomButton;
